export type MoovyUserGroup = 'ADMIN' | 'SALE' | 'LANDLORD'
export type MoovyAction = 'ALL' | 'READ' | 'CREATE' | 'EDIT' | 'DELETE'

export type MoovyResource = 'PARKING_EVENTS' | 'WHITELIST' | 'USER_DETAILS'

export type MoovyPermissionType = {
  action: MoovyAction[]
  resource: MoovyResource
}

export const isAllowed = (
  userPermissions: MoovyPermissionType[],
  action: MoovyAction,
  resource: MoovyResource,
) => {
  const userPermission: MoovyPermissionType | undefined = userPermissions.find(
    (permission) => permission.resource === resource,
  )
  return userPermission?.action?.includes(action) || false
}

const getPermission = (
  actions: MoovyAction[],
  resource: MoovyResource,
): MoovyPermissionType => {
  if (actions.includes('ALL')) {
    return {
      action: ['READ', 'CREATE', 'EDIT', 'DELETE'],
      resource: resource,
    }
  } else {
    return {
      action: actions,
      resource: resource,
    }
  }
}

export const hasPermission = (
  isAdmin: boolean,
  action: MoovyAction,
  resource: MoovyResource,
) => {
  const userPermissions: MoovyPermissionType[] = isAdmin
    ? [
        getPermission(['READ', 'EDIT'], 'PARKING_EVENTS'),
        getPermission(['ALL'], 'WHITELIST'),
        getPermission(['READ'], 'USER_DETAILS'),
      ]
    : [
        getPermission(['READ', 'EDIT'], 'PARKING_EVENTS'),
        getPermission(['READ'], 'WHITELIST'),
        getPermission(['READ'], 'USER_DETAILS'),
      ]
  return isAllowed(userPermissions, action, resource)
}

export const appRoutes = {
  ROOT: '/',
  USER_DETAILS: '/user',
  PARKING_EVENTS: '/parking-events',
  WHITELIST: '/exempt-vehicles',
}
